import { useSelector, useDispatch } from "react-redux";
import { fetchMarkersIfNeeded } from "../../api/features/markers/actions";
import { getMarkerLoadStatus } from "../../api/features/markers/selectors";
import { useEffect } from "react";

export default function useMarkerLoad() {
  const loadStatus = useSelector(getMarkerLoadStatus);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMarkersIfNeeded());
  }, [dispatch]);

  return loadStatus;
}
